import mixpanel from "mixpanel-browser";

const usePlaceholderMixpanelHook = () => {
    function trackBbStep({ cta = "", stepId = 0, ctaType = "" }) {
        const temp = {
            "Step ID": stepId || "-",
            Cta: cta,
            "Cta Type": ctaType,
        };
        console._log("track BB - Step Event", temp);

        mixpanel.track("BB - Step Event", temp);
    }

    function trackBbUpsellButton({ cta = "", formId = "", ctaType = "" }) {
        const temp = {
            "Form ID": formId,
            Cta: cta,
            "Cta Type": ctaType,
        };
        console._log("track BB - Upsell Button", temp);

        mixpanel.track("BB - Upsell Button", temp);
    }

    function trackPlaceholderBundle({ cta = "", formId = "", ctaType = "" }) {
        const temp = {
            "Form ID": formId,
            Cta: cta,
            "Cta Type": ctaType,
        };
        console._log("track Product Page Bundle Builder", temp);

        mixpanel.track("Product Page Bundle Builder", temp);
    }

    return { trackBbStep, trackBbUpsellButton, trackPlaceholderBundle };
};

export default usePlaceholderMixpanelHook;
